import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Marquee from './components/Marquee';
import Hero from './components/Hero';
import AboutUs from './components/AboutUs';
import WhyChoose from './components/WhyChoose';
import Students from './components/Students';
import Courses from './components/courses';
import ContactUs from './components/contactus';
import Reviews from './components/reviews';
import Login from './components/Login';
import './App.css';

function App() {
  // Track login state
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('token'));

  return (
    <Router>
      <div className="App">
        <div className="container">
          <Header isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />
          <Marquee />
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Hero />
                  <AboutUs />
                  <WhyChoose />
                </>
              }
            />
            <Route path="/students" element={<Students />} />
            <Route path="/Courses" element={<Courses />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/login" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
          </Routes>
          <Footer />
        </div>
      </div>
    </Router>
  );
}

export default App;